import { FRANCHISE_TEMPLATES } from "@/components/franchiseTemplates";

export const FranchiseTemplatePicker = ({ selected, onPick, onBrand, title = "Start from a franchise category" }) => {
  const current = FRANCHISE_TEMPLATES.find((t) => t.id === selected);
  return (
    <div data-testid="franchise-template-picker">
      <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">{title}</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {FRANCHISE_TEMPLATES.map((t) => {
          const Icon = t.icon;
          const on = t.id === selected;
          return (
            <button key={t.id} type="button" data-testid={`franchise-template-${t.id}`} onClick={() => onPick(t)}
              className={`flex items-center gap-2 rounded-lg border px-3 py-2.5 text-left text-sm transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${on ? "border-emerald-500 bg-emerald-500/10 text-emerald-200" : "border-slate-800 bg-slate-950/50 text-slate-300 hover:border-slate-600"}`}>
              <Icon className={`h-4 w-4 shrink-0 ${on ? "text-emerald-400" : "text-slate-500"}`} /><span className="leading-tight">{t.title}</span>
            </button>
          );
        })}
      </div>
      {current && onBrand && (
        <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="franchise-brand-chips">
          <span className="text-xs text-slate-500">Popular brands:</span>
          {current.examples.map((b) => (
            <button key={b} type="button" onClick={() => onBrand(b)} data-testid={`franchise-brand-chip-${b.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              className="rounded-full border border-slate-700 px-3 py-1 text-xs text-slate-300 hover:border-emerald-500 hover:text-emerald-300 transition-colors">{b}</button>
          ))}
        </div>
      )}
    </div>
  );
};
